function importAll(r) {
  let images = {};
  r.keys().map((item) => { images[item.replace('./', '')] = r(item); });
  return images;
}

const countryFlags = importAll(require.context('./assets/country-flag-icons/3x2', false, /\.(png|jpe?g|svg)$/));

export default countryFlags;
